<template>
	<div class="app-warapper">
		<AppHeader />
		<AppMain />
		<edit-pass ref="editPass"></edit-pass>
	</div>
</template>
<script>
import AppHeader from './components/AppHeader'
import AppMain from './components/AppMain'
import editPass from "@/components/EditPassword";
export default {
	name: 'Layout',
    components:{
        AppHeader,
        AppMain,
		editPass
	},
	watch: {

	},
	mounted() {
		let passwordExpiry = window.sessionStorage.getItem("passwordExpiry");
		if(window.sessionStorage.getItem("initPassFlag") == "1") {
			this.$confirm(
				"您的密码为初始密码，请尽快修改",
				{
					confirmButtonText: "确定",
					type: "warning",
					closeOnClickModal: false,
					closeOnPressEscape: false,
					showCancelButton: false,
					showClose: false
				}
			)
			.then(() => {
				this.$refs.editPass.init(false);
			})
			.catch(() => {});
			return
		}
		if (Number(passwordExpiry) >= 90) {
			this.$confirm(
				"您的密码已经超过" + passwordExpiry + "天未修改，请尽快修改",
				{
					confirmButtonText: "确定",
					type: "warning",
					closeOnClickModal: false,
					closeOnPressEscape: false,
					showCancelButton: false,
					showClose: false
				}
			)
			.then(() => {
				this.$refs.editPass.init(false);
			})
			.catch(() => {});

		}
	},
	methods:{

	}
}
</script>
